<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :clickableRows=false
        :items-per-page="small ? 20 : 10"
        :dark="dark"
        :sorter="true"
        :sorterValue="{ column: 'serial', asc: 'true' }"
        pagination
      >
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'CTableWrapper',
  props: { 
    items: Array,
    fields: {
      type: Array,
      default () {
        return [ 'serial',  'dateFrom', 'dateTo', 'msgType', 'fwVersion', 'upgradeDesc' ]
      }
    },
    caption: {
      type: String,
      default: 'SNProp'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    clickableRows: Boolean,
    dark: Boolean
  }
  ,
  methods: 
  {
    /*
    clickRow( item,index )
    {
      item.filter = (item.filter) ? false : true;
      this.$forceUpdate();
      var newSel = []
      var newSel2 = []
      for (var x=0; x< this.items.length;x++ )
      {
        if (this.items[x].filter == true)
        {
          newSel.push(this.items[x].serial)
          newSel2.push(this.items[x].imei)
        }
      }
      this.$store.commit('set', [ 'filterDevices',newSel ] )
      this.$store.commit('set', [ 'filterDevicesIMEI',newSel2 ]  )
    },      
    getFilterCheck (filter) {
      return filter != null ? filter : false;
    },
    getStatusColor(status) {
      return (status === 'Active') || (status === 'OK') ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    }, 
    */
    onTableChange () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        const agent = this.$refs.externalAgent
        this.loadedItems = agent.currentItems
        this.pages = Math.ceil(agent.sortedItems.length / 5)
      }, 1000)
    }
}  
}
</script>
